import React, { useState } from "react";
import ReactDOM from "react-dom";
import app from "../../../firebase-config";

function UsuarioPasado() {
  const [confirmar, setConfirmar] = useState(false);
  const logo = "./assets/logo.png";
  const correoLocal = localStorage.getItem("email");

  function restablecerPassword(event) {
    event.preventDefault();
    const { email } = event.target.elements;
    app
      .auth()
      .sendPasswordResetEmail(email.value)
      .then(function () {
        localStorage.clear();
      })
      .catch(function (error) {
        console.log(error);
      });
    setConfirmar(true);
  }

  const node = (
    <div className="hold-transition login-page">
      <div className="login-box">
        <div className="login-logo">
          <img alt="" src={logo} style={{ width: 120 }} />
        </div>
        {/* /.login-logo */}
        <div className="card">
          <div className="card-body login-card-body">
            <div className="login-logo" style={{ color: "#0B3688" }}>
              <b>Al parecer usted ya está registrado</b>
            </div>
            <p className="login-box-msg">
              Recuperar cuenta.<br></br>
              Se le enviará un link de recuperación.<br></br>
              Escriba su corrreo.
            </p>
            <form onSubmit={restablecerPassword}>
              <div className="input-group mb-3">
                <input
                  defaultValue={correoLocal}
                  name="email"
                  type="email"
                  className="form-control"
                  placeholder="ejemplo@correo.com"
                />
                <div className="input-group-append">
                  <div className="input-group-text">
                    <span className="fas fa-envelope" />
                  </div>
                </div>
              </div>
              <br></br>
              <div className="row mx-auto">
                <div className="col-10 m-2 mx-auto">
                  <button
                    type="submit"
                    className="btn btn-primary btn-block"
                    style={{
                      background: "#0B3688",
                      border: "#0B3688",
                    }}
                  >
                    Enviar
                  </button>
                </div>
                {/* /.col */}
              </div>
            </form>
            <div className="col-10 m-2 mx-auto">
              <a
                href="/login"
                className="btn btn-primary btn-block"
                style={{
                  background: "#0B3688",
                  border: "#0B3688",
                }}
              >
                Regresar
              </a>
            </div>
            <br></br>
          </div>
          {/* /.login-card-body */}
        </div>
      </div>
    </div>
  );
  const node2 = (
    <div className="hold-transition login-page">
      <div className="login-box">
        <div className="login-logo">
          <img alt="" src={logo} style={{ width: 120 }} />

        </div>
        {/* /.login-logo */}
        <div className="card">
          <div className="card-body login-card-body">
            <div className="login-logo" style={{ color: "#0B3688" }}>
              <b>Listo revise su bandeja de entrada.</b>
            </div>

            <div className="col-10 m-2 mx-auto">
              <a
                href="/login"
                className="btn btn-primary btn-block"
                style={{
                  background: "#0B3688",
                  border: "#0B3688",
                }}
              >
                Regresar a Login
              </a>
            </div>
            <br></br>
          </div>
          {/* /.login-card-body */}
        </div>
      </div>
    </div>
  );
  if (confirmar) {
    return ReactDOM.createPortal(node2, document.getElementById("login"));
  } else {
    return ReactDOM.createPortal(node, document.getElementById("login"));
  }
}
export default UsuarioPasado;
